'use client';
import { useRouter } from '@/navigation';
import React, { useState } from 'react';
import { SupportedLanguage } from '@/constants';

const SearchButton = ({
  onClick,
}: {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}) => {
  return (
    <button
      className="absolute right-[1px] top-[2px] rounded-[8px] bg-white px-[20px] py-[20px] lg:py-[38px]"
      aria-label="Search"
      onClick={onClick}
    >
      <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.66665 3.33398C12.8883 3.33398 15.5 5.94566 15.5 9.16732C15.5 10.4776 15.068 11.687 14.3386 12.6608L16.9226 15.2448C17.248 15.5702 17.248 16.0978 16.9226 16.4233C16.5971 16.7487 16.0695 16.7487 15.7441 16.4233L13.1601 13.8393C12.1863 14.5687 10.9769 15.0007 9.66665 15.0007C6.44499 15.0007 3.83331 12.389 3.83331 9.16732C3.83331 5.94566 6.44499 3.33398 9.66665 3.33398ZM9.66665 13.334C11.9678 13.334 13.8333 11.4685 13.8333 9.16732C13.8333 6.86613 11.9678 5.00065 9.66665 5.00065C7.36546 5.00065 5.49998 6.86613 5.49998 9.16732C5.49998 11.4685 7.36546 13.334 9.66665 13.334Z"
          fill="#676779"
        />
      </svg>
    </button>
  );
};
export const SearchInput = ({
  locale,
  placeHolder,
  searchValue,
}: {
  locale: SupportedLanguage;
  placeHolder: string;
  searchValue?: string;
}) => {
  const [query, setQuery] = useState(searchValue ?? '');
  const router = useRouter();

  const onSearch = (query: string) => {
    const trimmedQuery = query.trim();
    if (trimmedQuery)
      router.push(`/faq/search?q=${trimmedQuery}`, { locale: locale });
  };

  const classNames =
    'w-full rounded-[8px] border border-3b-text-disabled px-[12px] py-[19px] placeholder:text-3b-text-hint lg:h-[100px]';

  return (
    <div className="relative">
      <input
        className={classNames}
        aria-label={placeHolder}
        placeholder={placeHolder}
        onKeyUp={e => {
          if (e.key === 'Enter') {
            onSearch(query);
          }
        }}
        onChange={e => {
          setQuery(e.target.value);
        }}
        value={query}
      />
      <SearchButton
        onClick={() => {
          onSearch(query);
        }}
      />
    </div>
  );
};
